import React, { useEffect, useState, useRef, useCallback } from "react";

import { ITableData } from "../../types/table-type";
import { IAggregateFormValue } from "../../types/form-type";
import { Language } from "../../types/global-type";

import textfit from "../../lib/textFit";
import CalculationDataBySummary from "../../class/CalculationDataBySummary";
import { usePrevious } from "../../utils/hooks";

import { Container, NumberContainer } from "./styled";

interface IProps {
  tableData: ITableData;
  formValue: IAggregateFormValue;
  onload?: () => void;
  isExpand: boolean;
  locale: Language;
}

const Summary: React.FC<IProps> = ({ tableData, formValue, onload, isExpand, locale }) => {
  const numberContainerRef = useRef<HTMLDivElement>(null);
  const [value, setValue] = useState<JSX.Element | JSX.Element[]>();
  // 第一次计算 option 完成后发送
  const prevOption = usePrevious(value);
  useEffect(() => {
    if (!prevOption && !!value) {
      if (onload) onload();
    }
  }, [value, onload, prevOption]);

  const handleWindowResize = useCallback(() => {
    numberContainerRef?.current &&
      textfit(numberContainerRef?.current, {
        minFontSize: 10,
        maxFontSize: 500,
      });
  }, []);

  useEffect(() => {
    const calc = new CalculationDataBySummary({ tableData, formValue, locale });
    const newValueString = calc.getValue();
    setValue(newValueString);
  }, [tableData, formValue, locale, handleWindowResize]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);
  useEffect(() => {
    if (value !== undefined) {
      handleWindowResize();
    }
  }, [value, handleWindowResize]);

  return (
    <Container>
      <NumberContainer id="test" isExpand={isExpand} ref={numberContainerRef} className="summary-value-container">
        <span className="textFitted">{value}</span>
      </NumberContainer>
    </Container>
  );
};
export default Summary;
